import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigLiquidModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async liquidConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.liquidConfig(patientId)
    },
    async updateLiquidConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updateLiquidConfig(config)
    }
  }
}
